import { getProp } from '@verkstedt/storybook-store-decorator'

const withCrossSell = path => Component => {
  const Crosssell = props => {
    const moduleProps = getProp(path)
    return <Component {...props} {...moduleProps} />
  }
  Crosssell.propTypes = { ...Component.propTypes }

  return Crosssell
}

export default withCrossSell
